// 과제를 출제할 수 있는 지인에듀 플랜. 서버의 assignment/views.py 와 같은 목록이다.
// basic, free, 미가입은 문제지 목록만 볼 수 있고 출제 단계에서 막힌다.
export const ASSIGNMENT_ALLOWED_PLAN_LIST = ["plus", "premium"];

export const ASSIGNMENT_PLAN_REQUIRED_MESSAGE =
  "Plus, Premium 사용자만 출제 가능합니다.\n플랜을 업그레이드해주세요.";

export const canCreateAssignment = (plan) =>
  ASSIGNMENT_ALLOWED_PLAN_LIST.includes(plan);
